import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ShapeType } from '@ridango/components';

@Directive({ selector: '[rwidgetShape]' })
export class ShapeDirective implements AfterViewInit {
    @Input('rwidgetShape') shapeType: string;

    @Input() set shapeText(value: string) {
        this._shapeText = value;

        if (this.createdElement && this.createdElement.innerText) {
            this.createdElement.innerText = value;
        }
    }

    private _shapeText: string;

    private createdElement;

    public readonly generalClasses = [
        'flex',
        'items-center',
        'justify-center',
        'w-full',
        'h-full',
        'box-border',
        'vl-app-light:border',
        'vl-app-light:border-solid',
        'vl-app-light:border-white'
    ];

    public readonly squaredParentClasses = ['w-7', 'h-7', 'border-[2px]', 'border-solid'];

    public readonly rectangleParentClasses = ['h-7', 'min-w-fit', 'border-[2px]', 'border-solid'];

    public readonly rectangleClasses = ['px-1'];

    public readonly roundedClasses = ['rounded-full'];

    public readonly roundedParentClasses = [
        'h-7',
        'min-w-7',
        'box-content',
        'rounded-full',
        'vl-app-light:border-2',
        'vl-app-light:border-solid',
        'orb-app-light:border-2',
        'var-app-light:border-[1.5px]'
    ];

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngAfterViewInit(): void {
        this.initialize();
    }

    public initialize(): void {
        switch (this.shapeType) {
            case ShapeType.ROUNDED:
                this.addRoundedElement();
                break;
            case ShapeType.RECTANGLE:
                this.addRectangleElement();
                break;
            case ShapeType.SQUARED:
                this.addSquareElement();
                break;
            default:
                console.warn(
                    "[SHAPE DIRECTIVE]: You put shape type which doesn't exist." + `Type = [${this.shapeType}]`
                );
                this.addRoundedElement();
                break;
        }
    }

    public addRoundedElement(): void {
        const newElement = this.addElementInsideParent();

        if (this._shapeText.length > 2) {
            this.renderer.addClass(newElement, 'px-1.5');
        } else {
            //set width to match height h-7 added above
            this.renderer.addClass(this.el.nativeElement, 'w-7');
        }
        // Add tailwind classes to rounded element
        this.roundedClasses.forEach((className) => {
            this.renderer.addClass(newElement, className);
        });

        // Change style for parent
        this.roundedParentClasses.forEach((className) => {
            this.renderer.addClass(this.el.nativeElement, className);
        });
    }

    public addRectangleElement(): void {
        const newElement = this.addElementInsideParent();

        // Add tailwind classes to parent element
        this.rectangleParentClasses.forEach((className) => {
            this.renderer.addClass(this.el.nativeElement, className);
        });

        this.rectangleClasses.forEach((className) => {
            this.renderer.addClass(newElement, className);
        });
    }

    public addSquareElement(): void {
        this.addElementInsideParent();

        // Add tailwind classes to parent element
        this.squaredParentClasses.forEach((className) => {
            this.renderer.addClass(this.el.nativeElement, className);
        });
    }

    private addElementInsideParent() {
        const newElement = this.renderer.createElement('div');
        const text = this.renderer.createText(this._shapeText);

        this.createdElement = newElement;
        this.renderer.appendChild(newElement, text);
        this.renderer.appendChild(this.el.nativeElement, newElement);

        this.generalClasses.forEach((className) => {
            this.renderer.addClass(newElement, className);
        });

        return newElement;
    }
}
